exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".txt-blue[_v-89d60f68]{color:#00e}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-89d60f68&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/promotion/index.vue
// module id = 368
// module chunks = 0